export default {
  saleDrug: () => import('./saleDrug/index.vue'), // 直接售药
  waitFee: () => import('./waitFee/index.vue'), // 待收费
  waitFeeDetail: () => import('./waitFeeDetail/index.vue'), // 待收费详情
  feeList: () => import('./feeList/index.vue'), // 已收费
  feeDetail: () => import('./feeDetail/index.vue'), // 已收费详情
  returdFee: () => import('./returdFee/index.vue'), // 退费
  returd: () => import('./returd/index.vue'), // 已退费
  returdDetail: () => import('./returdDetail/index.vue'), // 已退费详情
  arrears: () => import('./arrears/index.vue'), // 欠费管理
  arrearsDetail: () => import('./arrearsDetail/index.vue'), // 欠费管理详情
  pay: () => import('./pay/index.vue'), // 支付弹窗
  financeToday: () => import('./financeToday/index.vue'), // 当日财务
};
